import { lazy } from 'react';

// Lazy load heavy components
export const LazyDashboard = lazy(() => import('../components/Dashboard/Dashboard'));
export const LazyContentHub = lazy(() => import('../components/Content/ContentHub'));
export const LazyAudienceHub = lazy(() => import('../components/Audience/AudienceHub'));
export const LazyReaderHub = lazy(() => import('../components/Reader/ReaderHub'));
export const LazyAnalyticsHub = lazy(() => import('../components/Insights/AnalyticsHub'));
export const LazyUnifiedAnalyticsHub = lazy(() => import('../components/Analytics/UnifiedAnalyticsHub'));
export const LazyUnifiedContentHub = lazy(() => import('../components/Content/UnifiedContentHub'));
export const LazyUnifiedSettingsHub = lazy(() => import('../components/Settings/UnifiedSettingsHub'));
export const LazyAutomationHub = lazy(() => import('../components/Automation/AutomationHub'));
export const LazyBrandHub = lazy(() => import('../components/Brand/BrandHub'));
export const LazyAccountHub = lazy(() => import('../components/Account/AccountHub'));

// Lazy load heavy reader components
export const LazyEnhancedArticleReader = lazy(() => import('../components/Reader/EnhancedArticleReader'));
export const LazySmartDiscoverySystem = lazy(() => import('../components/Reader/SmartDiscoverySystem'));
export const LazyReadingChallenges = lazy(() => import('../components/Reader/ReadingChallenges'));
export const LazyReadingGroups = lazy(() => import('../components/Reader/ReadingGroups'));
export const LazySmartHighlighting = lazy(() => import('../components/Reader/SmartHighlighting'));
export const LazyTextToSpeech = lazy(() => import('../components/Reader/TextToSpeech'));

// Lazy load media components
export const LazyMediaStudioDashboard = lazy(() => import('../components/Media/ModernMediaHub'));
export const LazyAudioRecordingStudio = lazy(() => import('../components/Media/AudioRecordingStudio'));
export const LazyImageEditor = lazy(() => import('../components/Media/ImageEditor'));

// Lazy load editor components
export const LazyPostEditor = lazy(() => import('../components/Posts/PostEditor'));
export const LazyRichTextEditor = lazy(() => import('../components/Editor/RichTextEditor'));

// Lazy load testing components
export const LazyTestingDashboard = lazy(() => import('../components/Testing/TestingDashboard'));
export const LazyComprehensiveTestingPage = lazy(() => import('../pages/ComprehensiveTestingPage'));

// Lazy load migration components
export const LazyMigrationPage = lazy(() => import('../pages/MigrationPage'));
export const LazyOnboardingWizard = lazy(() => import('../components/Onboarding/OnboardingWizard'));